import axios from "axios";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyAw--VkXMUYbx9o49tRhxWD0YF8zVGTMN4",
    authDomain: "hss-notification.firebaseapp.com",
    projectId: "hss-notification",
    storageBucket: "hss-notification.firebasestorage.app",
    messagingSenderId: "305807729266",
    appId: "1:305807729266:web:cbc728db7622ebc939d8eb",
    measurementId: "G-5QFHQ8MMGF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const generateToken = async () => {
    const permission = await Notification.requestPermission();
    if(permission === "granted") {
        const token = await getToken(messaging, {
            vapidKey: "BFkqFth1hIUBERqRVaY2qSCWav90xtr5f71JRENjjaMGtr6IkvqJJG8PhVetZpkA09DsW3mtQ4VpJQi3z0lcoW8"
        })
        const updateDeviceToken = await axios.post("/api/user/device_id_update", {
            device_id: token,
        });
    }
};